import React, { Component } from "react";
import ReactDOM from "react-dom";
import PropTypes from "prop-types";
import "./Checkbox.css";

export class Checkbox extends Component {
  constructor(props){
    super(props)
    this.state = {
      checked: props.checked
    };
  }

  static propTypes = {
    checked: PropTypes.bool.isRequired,
    data: PropTypes.any,
    stateControlled: PropTypes.bool,
    cls: PropTypes.string,
    readonly: PropTypes.bool,
    disabled: PropTypes.bool,
    onCheckboxChange: PropTypes.func,
    checkBoxLabel: PropTypes.string
  }

  static defaultProps = {
    onCheckboxChange: ()=>{},
    cls: "",
    readonly: false,
    disabled: false,
    checkBoxLabel: ""
  }

  componentWillReceiveProps(nextProps) {
    if(nextProps.checked !== this.props.checked){
      this.setState({
        checked: nextProps.checked
      });
    }
  }
  toggleCheckbox(data,e) {
    if (this.props.stateControlled) {
      this.setState({
        checked: !this.state.checked
      });
      this.props.onCheckboxChange(this.state.checked, e, data);
    } else {
      var checkboxEl = ReactDOM.findDOMNode(this.refs.checkbox);
      this.props.onCheckboxChange(checkboxEl.classList.contains("active"), e, data);
    }
  }

  render() {
    let currentCheckedState = this.props.stateControlled ? this.state.checked : this.props.checked;
    let activeCls = currentCheckedState ? "active" : "";
    let isDisabled = (this.props.disabled || this.props.readonly)
    let readOnlyCls = isDisabled ? "checkbox-readonly" : "";
    return (
      <div className={`checkbox-row ${this.props.cls}`} 
            onClick={!isDisabled ? this.toggleCheckbox.bind(this,this.props.data) : ()=>{}}>
        <div ref="checkbox" className={`checkbox-btn ${activeCls} ${readOnlyCls}`}>
          <div className={"checkbox-highlight"}/>
        </div>
        { this.props.checkBoxLabel
          ? <div className={"setting-text"}>
              {this.props.checkBoxLabel}
            </div> 
          : ""}
      </div>
    );
  }
}

export default Checkbox;